import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  wufooCase: {},
};

export const wufooCaseSlice = createSlice({
  name: "wufooCase",
  initialState,
  reducers: {
    storeWufooCase: (state, action) => {
      state.wufooCase = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { storeWufooCase } = wufooCaseSlice.actions;

export default wufooCaseSlice.reducer;
